import React, { useState, useEffect } from 'react';

const PWAInstallPrompt = () => {
    const [showPrompt, setShowPrompt] = useState(false);

    useEffect(() => {
        // Don't show on public pages
        const isPublicPage = window.location.pathname.includes('/public/');
        if (isPublicPage) {
            return;
        }

        // Check if it's iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // Check if it's already in standalone mode (installed)
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

        // Only show for iOS and NOT standalone
        if (isIOS && !isStandalone) {
            // Show prompt after a short delay
            const timer = setTimeout(() => setShowPrompt(true), 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    if (!showPrompt) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            backgroundColor: 'white',
            borderRadius: '15px',
            padding: '20px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            zIndex: 9999,
            border: '1px solid #e2e8f0',
            animation: 'slideUp 0.5s ease-out'
        }}>
            <div className="d-flex align-items-center mb-3">
                <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#3182ce',
                    borderRadius: '10px',
                    marginRight: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '24px',
                    fontWeight: 'bold'
                }}>K</div>
                <div>
                    <h6 className="mb-0 fw-bold">Install KIT-CRM</h6>
                    <p className="mb-0 text-muted small">Get notifications and faster access</p>
                </div>
                <button
                    onClick={() => setShowPrompt(false)}
                    style={{
                        background: 'none',
                        border: 'none',
                        marginLeft: 'auto',
                        fontSize: '20px',
                        color: '#cbd5e0'
                    }}
                >&times;</button>
            </div>

            <div className="p-3 bg-light rounded-3 small">
                <div className="d-flex align-items-center mb-2">
                    1. Tap the <strong>"Share"</strong> button <i className="bi bi-share ms-2" style={{ color: '#007aff', fontSize: '18px' }}></i>
                </div>
                <div className="d-flex align-items-center">
                    2. Select <strong>"Add to Home Screen"</strong> <i className="bi bi-plus-square ms-2" style={{ fontSize: '18px' }}></i>
                </div>
            </div>

            <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default PWAInstallPrompt;
